import type { OptionsDocument } from 'paintscout'

export function mapLeadSourceToPublic({
  options,
  lead_source = ''
}: {
  options: OptionsDocument
  lead_source: string
}): string {
  type SourceValue = { label?: string; name?: string }
  const sourceTypes = ['leadSources', 'contactSources', 'companySources', 'quoteSources'] as const
  const leadSource = sourceTypes.reduce<undefined | SourceValue>((found, type) => {
    if (found) return found
    const values = (options?.options?.[type]?.values ?? {}) as Record<string, SourceValue>
    return (
      values[lead_source] ?? Object.values(values).find((ls) => ls.label === lead_source || ls.name === lead_source)
    )
    // eslint-disable-next-line unicorn/no-useless-undefined
  }, undefined)
  if (leadSource) {
    return leadSource.label ?? ''
  }
  return ''
}
